import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { billing as actions } from "actions";
import { createOptions } from "./Card_Element";
import {
  CardElement,
  useStripe,
  useElements
} from "@stripe/react-stripe-js";

import Message from "components/message";
import Buttons from "components/elements/Buttons";
import Button from "components/elements/Button";

function AuthorizeCard({
  user,
  messages,
  locale,
  finalizePaymentMethod,
  history
}) {
  const stripe = useStripe();
  const elements = useElements();

  const [validation, setValidation] = useState({ error: true, message: "" });
  const [formComplete, setFormComplete] = useState(false);
  const [authFail, setAuthFail] = useState(false);

  useEffect(() => {
    //console.log("✅ AuthorizeCard mounted");
  }, []);

  const handleChange = ({ error, complete }) => {
    if (error) {
      setValidation({ error: true, message: error.message });
    } else {
      setValidation({ error: false, message: "" });
    }

    setFormComplete(complete);
  };

  const submit = async () => {
    setAuthFail(false);

    if (!stripe || !elements) {
      console.warn("Stripe.js hasn't loaded yet.");
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const result = await stripe.confirmCardSetup(user.stripeClientSecret, {
      payment_method: {
        card: cardElement
      }
    });

    if (result.error) {
      console.error(result.error.message);
      setAuthFail(true);
    } else {
      finalizePaymentMethod(result.setupIntent, () => {
        history.push("/userhome/user_account/subscription");
      });
    }
  };

  return (
    <>
      {authFail && <Message warning message="authorizationFailed" />}
      <Message warning message="requiresPaymentMethod" />
      <div className="checkout notification" style={{ padding: 8 }}>
        <div className="columns is-2 is-variable is-flex-desktop is-mobile is-multiline">
          <div className="column is-6-desktop is-12-mobile is-flex-desktop">
            <div className="box" style={{ width: "100%" }}>
              <p>{messages.labels.enterCardDetails[locale]}</p>
              <br />
              <CardElement
                onChange={handleChange}
                options={createOptions()}
              />
              {validation.error && (
                <p className="is-danger help">{validation.message}</p>
              )}
            </div>
          </div>
          <div className="column is-6-desktop is-12-mobile is-flex-desktop">
            <div className="box" style={{ width: "100%" }}>
              <Buttons>
                <Button
                  className="is-link is-fullwidth"
                  group="stripe"
                  name="updateCard"
                  onClick={submit}
                  disabled={validation.error || !formComplete}
                />
              </Buttons>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default connect(null, actions)(AuthorizeCard);
